import { useEffect } from "react";
import { GLOBAL_IMAGES } from "../../assets/asset";
import BigPrimaryButton from "../ui/BigPrimaryButton";

export default function FirstLoginDemo({ showDemo, handleDemo }) {
  useEffect(() => {
    const scrollY = window.scrollY;
    const { style: bodyStyle } = document.body;
    const { style: htmlStyle } = document.documentElement;

    const previousBodyOverflow = bodyStyle.overflow;
    const previousBodyPosition = bodyStyle.position;
    const previousBodyTop = bodyStyle.top;
    const previousBodyWidth = bodyStyle.width;
    const previousHtmlOverflow = htmlStyle.overflow;

    htmlStyle.overflow = "hidden";
    bodyStyle.overflow = "hidden";
    bodyStyle.position = "fixed";
    bodyStyle.top = `-${scrollY}px`;
    bodyStyle.width = "100%";

    return () => {
      htmlStyle.overflow = previousHtmlOverflow;
      bodyStyle.overflow = previousBodyOverflow;
      bodyStyle.position = previousBodyPosition;
      bodyStyle.top = previousBodyTop;
      bodyStyle.width = previousBodyWidth;
      window.scrollTo(0, scrollY);
    };
  }, []);

  return (
    <div className="fixed inset-0 overflow-hidden overscroll-y-none z-40 bg-black/60">
      <img
        src={GLOBAL_IMAGES.foxImage}
        className={`h-80 ${
          showDemo === true || showDemo === 1 ? "bottom-0 z-30" : "top-7"
        } absolute w-auto`}
      />
      <img
        className={`absolute left-40  ${
          showDemo === true || showDemo === 1 ? "bottom-40 ml-8" : " top-40"
        }`}
        src={
          showDemo === true
            ? GLOBAL_IMAGES.chatBubble1
            : showDemo === 1
            ? GLOBAL_IMAGES.chatBubble2
            : GLOBAL_IMAGES.chatBubble
        }
      />
      <div className="absolute z-50 bottom-10 right-10">
        <BigPrimaryButton
          onClick={handleDemo}
          title={showDemo === true || showDemo === 1 ? "Next" : "Done"}
        />
      </div>
    </div>
  );
}
